import { defineMessages } from "react-intl";

import {
	resultMessages,
	validator
} from "lib/build/forms/ktx/transplantation-screening/cardiology/transtorachalisEcho";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	transtorachalisEcho: {
		id: "ktx.transtorachalis_echo.title",
		defaultMessage: "Transtorachalis ECHO"
	},
	result: {
		id: "ktx.transtorachalis_echo.field.result",
		defaultMessage: "Eredmény"
	},
	description: {
		id: "ktx.transtorachalis_echo.field.description",
		defaultMessage: "Megjegyzés"
	}
});

const fields: {
	[key: string]: FieldData;
} = {
	result: {
		type: "field",
		path: ["result"],
		label: messages.result,
		errorMessages: genericErrorMessages,
		input: {
			type: "button-group",
			props: { labels: resultMessages }
		}
	},
	description: {
		type: "field",
		path: ["description"],
		label: messages.description,
		errorMessages: genericErrorMessages,
		input: {
			type: "textarea",
			props: {}
		}
	}
};

const fieldset: FieldsetData = {
	rows: [
		{ columns: [{ width: 12, field: fields.result }] },
		{ columns: [{ width: 12, field: fields.description }] }
	]
};

export const node: LeafNode = {
	id: "ktx_transtorachalisEcho",
	value: {
		schemaId: "transtorachalisEcho",
		title: messages.transtorachalisEcho,
		validator,
		fieldset,
		applyCurrentDate: false
	}
};
